import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { eSignature } from '../../../shared/models/eSignature';
import { PanelList } from '../../../shared/models/panel-list';
import { CommonService } from '../../../shared/services/common.service';
import { UserTrainingPlanService } from '../services/user-training-plan.service';
import { TrainingQuizAnswerDto } from '../models/trainingQuizAnswerDto';
import { CourseProficiencyQuiz } from '../../../course/models/CourseProficiencyQuiz';
import { CourseService } from '../../../course/services/course.service';
import { DocumentService } from '../../../document/services/document.service';
import { MySpaceConstants } from '../../my-space-constants';

@Component({
  selector: 'app-training-occurrence-quiz-audit',
  templateUrl: './training-occurrence-quiz-audit.component.html',
  styleUrls: ['./training-occurrence-quiz-audit.component.scss']
})
export class TrainingOccurrenceQuizAuditComponent implements OnInit{

  isTrainingRequirementHistoryModelOpen = false;
  isESignatureModalOpen=false;
 isQuizAuditAnswerOpen = false;
  timeZoneFormat:string= MySpaceConstants.UTC_TimeFormat;
  eSignatureDetails={} as eSignature;
  quizQuestions ?: string;
  quizResponse ?: string;
  isQuizModalOpen = false;
  quizData: any;
  
  @Input() trainingQuizAnswerDetails : TrainingQuizAnswerDto[] = []
  @Input() trainingRequirementType ?: string
  @Input() documentVersionNumber ?: number
  @Input() trainingItemNumber ?: string;
  
  trainingQuizAnswerAuditListInput: PanelList = {
    title: undefined,
    lists: [],
    enableFilter: false,
    enableSort: false,
    enableSelection: false,
  };
  noData: boolean = false;
  constructor(private commonService: CommonService, private userTrainingPlanService: UserTrainingPlanService, 
    private courseService: CourseService, private documentService : DocumentService, private cd : ChangeDetectorRef) {
    
  }
  ngOnInit() {
    this.trainingQuizAnswerAuditListInput.lists = this.trainingQuizAnswerDetails;
    this.isQuizAuditAnswerOpen = true;
  }

  openESignature(eSignatureInfo : any){
    this.isESignatureModalOpen=true;
    this.eSignatureDetails.esignature=eSignatureInfo.eSignature,
    this.eSignatureDetails.esignatureDateTime=eSignatureInfo.eSignatureDateTime,
    this.eSignatureDetails.esignatureMeaning=eSignatureInfo.eSignatureMeaning
  }

  openQuiz(quizResponse ?: string, quizQuestions ?: string){
    this.isQuizModalOpen = false;
    this.cd.detectChanges();
    if(this.trainingRequirementType == MySpaceConstants.TrainingRequirementType_Course){
      this.courseService.getCourseProficiencyQuizDetails(this.trainingItemNumber).subscribe((courseProficiencyQuiz: CourseProficiencyQuiz)=>{
        this.quizData = courseProficiencyQuiz;
        this.quizData.quiz = quizQuestions;
        this.quizResponse = quizResponse;
        this.isQuizModalOpen = true;
      })
    }
    else if(this.trainingRequirementType== MySpaceConstants.TrainingRequirementType_Document){
      this.documentService.getDocumentProficiencyQuizDetails(this.trainingItemNumber!,
        Number(this.documentVersionNumber)).subscribe((response) => {
          this.quizData  = response;
          this.quizData.quiz = quizQuestions;
          this.quizResponse = quizResponse;
          this.isQuizModalOpen = true;
        })
    }
  }

}
